import { FilterChipData } from "../../../../../../Components/FilterShowcase/filterShowcase.models";
import { AgentsFilters } from "../../../../agents.model";
import { AGENT_NAME_KEY, AGENCY_NAME_KEY, USER_TYPE_KEY } from "../../../../agents.constants";

export type AgentsFilterChipData = FilterChipData<keyof AgentsFilters>;

const addChip = (
    result: AgentsFilterChipData[],
    config: {
        key: AgentsFilterChipData["key"];
        label: string;
        values: string[];
    }
): void => {
    const { key, label, values } = config;
    if (!values.length) return;

    result.push({
        key,
        label,
        titles: values,
    });
};

export const buildAgentsFilterChips = (filters: AgentsFilters): AgentsFilterChipData[] => {
    const result: AgentsFilterChipData[] = [];

    addChip(result, { key: USER_TYPE_KEY, label: "User Type", values: filters.userType });
    addChip(result, { key: AGENCY_NAME_KEY, label: "Agency Name", values: filters.agencyName });
    addChip(result, { key: AGENT_NAME_KEY, label: "Agent Name", values: filters.agentName });

    return result;
};
